<template>
  <div class="page" id="glory">
    <!-- <router-link to="/">
      <img src="@/assets/backTo.jpg" class="back_left" />
    </router-link> -->
    <van-overlay :show="show" v-if="addStar">
      <!-- <div class="harvest" @click.stop> -->
      <div class="harvest flex">
        <img src="@/assets/harvest.png" alt class="star" />
        <img
          src="@/assets/harvest-button.png"
          alt
          class="btn"
          @click="signup"
        />
      </div>
    </van-overlay>

    <img src="@/assets/pendant.png" alt class="pendant" />
    <div class="starbox">
      <div class="progress">
        <div class="bar">
          <div
            class="progress_bar"
            :style="`width:${progress_bar_style}%`"
          ></div>
        </div>
        <div
          class="star"
          :class="star_cur == index ? 'cur' : ''"
          v-for="(item, index) in stars"
          :key="index"
        >
          <img
            :src="
              require(`@/assets/star${index + 1}-${
                index <= star_cur ? 'yellow' : 'grey'
              }.png`)
            "
            alt
            v-show="star_cur != index"
          />
          <img
            :src="
              require(`@/assets/star${index == 4 ? `5-yellow` : `-light`}.png`)
            "
            alt
            v-show="star_cur == index"
          />
        </div>
      </div>
      <div class="star_text">
        <div class="text" v-for="(item, index) in stars" :key="index">
          第{{ index + 1 }}颗
        </div>
      </div>

      <div class="text" v-if="no_cert">暂未获得荣誉证书</div>
    </div>

    <div class="tip" v-if="no_cert">
      <div class="title">活动认证</div>

      <div class="content">
        <p>· 活动结束后，你们家庭将获得本次活动专属认证。</p>
        <p>想了解更多党史知识，可登录学习强国继续学习。</p>
      </div>
    </div>
    <div class="tip" v-if="!no_cert">
      <div class="title">温馨结语</div>
      <div class="content">
        <b>{{ userName }}</b> 家庭，你们是万个家庭中第
        <b>{{ userIndex }}</b>
        个参与活动的家庭，恭喜你们共同完成了罗湖区教育系统“小手拉大手”万个家庭学党史线上亲子活动。
        学史以明智，鉴往而知来；学习不停步，永远跟党走。
      </div>
    </div>

    <img
      src="@/assets/honor-button.png"
      alt
      class="honor btn"
      v-if="!no_cert"
      @click="toCert"
    />
    <img
      src="@/assets/Back-to-home.png"
      alt
      class="back btn"
      @click="toIndex"
    />
  </div>
</template>

<script>
import index from "./index.js";

export default {
  ...index,
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
